import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import QuotationCompactList from "../components/QuotationCompactList";

const QuotationSplitView = () => <MasterDetailLayout list={<QuotationCompactList />} />;

export default QuotationSplitView;
